<template>
    <td class="text-right table-icons">
        <b-dropdown v-if="showKsefNumberIcon"
                    boundary="viewport"
                    class="ksef-number-dropdown"
                    menu-class="ksef-number-menu"
                    no-caret
                    right
                    toggle-class="btn-ksef-number"
                    variant="link">
            <template #button-content>
                <span :data-original-title="__('transfer_ksef_number')"
                      class="text-bold"
                      data-placement="top"
                      data-toggle="tooltip"
                      style="color: #1ab394;font-size: 16px">e</span>
            </template>
            <div class="ksef-number-content text-nowrap">
                <span class="text-bold">{{ transfer.ksef_number }}</span>
                <a :data-original-title="__('copy')"
                   class="copy-to-clipboard m-l-xs"
                   data-placement="top"
                   data-toggle="tooltip"
                   href="#"
                   @click.prevent="copyKsefNumber">
                    <i class="fa fa-copy"></i>
                </a>
            </div>
        </b-dropdown>
          <span v-if="showCheckVatListIcon"  :data-original-title="__('vat_payers_list')" data-placement="top"
                data-toggle="tooltip"
                style="cursor: pointer;border-radius: 10px; width: 20px; height: 20px"
                :class="labelClass"
                @click="openModalCheckVatList">R</span>
        <a v-if="transfer.made_from === 'document'" :data-original-title="__(transfer.status)" data-placement="top"
           data-toggle="tooltip" @click="clickIcon">
            <span v-if="transfer.status === 'not_confirmed'"
                  class="label label-danger">{{ __('not_confirmed_acronym') }}</span>
            <span v-if="transfer.status === 'rejected'"
                  class="label label-black">{{ __('rejected_acronym') }}</span>
            <span v-if="transfer.status === 'cancelled'"
                  class="label label-black">{{ __('cancelled_acronym') }}</span>
            <span v-if="transfer.status === 'confirmed'"
                  class="label label-plain">{{ __('confirmed_acronym') }}</span>
        </a>
        <a v-if="transfer.made_from === 'disposition'" :data-original-title="__('disposition')"
           data-placement="top" data-toggle="tooltip">
            <span class="label label-plain">{{ __('disposition_acronym') }}</span>
        </a>
        <a v-if="transfer.has_attachment" :data-original-title="__('download_attachment')"

           @click="$emit('downloadLink', transfer.attachment_url)"
           data-placement="top"
           data-toggle="tooltip">
            <i class="fas fa-paperclip"></i>
        </a>
        <a v-if="list_type !== 'rest'" :data-original-title="__('edit_contractor')" data-placement="top"
           data-toggle="tooltip"
           @click="$emit('editContractor', transfer.contractor.id, list_type, list_index, transfer_index)">
            <i class="fa fa-pen"></i>
        </a>
        <a v-if="list_type !== 'rest'" :data-original-title="__('move_to_another_group')" data-placement="top"
           data-toggle="tooltip"
           @click="$emit('movedown', list_type, list_index, transfer_index)">
            <i class="fas fa-arrow-down"></i>
        </a>
        <a v-if="list_index > 0 || list_type === 'rest' || (list_type === 'iban_swift' && transfer.currency === 'EUR')" :data-original-title="list_type === 'rest' ?__('move_to_default_list') :__('move_to_another_group')" data-placement="top"
           data-toggle="tooltip"
           @click="$emit('moveup', list_type, list_index, transfer_index)">
            <i class="fas fa-arrow-up"></i>
        </a>
    </td>
</template>

<script>
import events from './../../services/Events.js';

export default {
    name: "RowIcons",
    props: ['transfer', 'list_type', 'list_index', 'transfer_index'],
    data() {
        return {
            labelClass: '', // Reaktywna zmienna na klasę
        };
    },
    methods: {
        //numer KSeF jest juz w pamieci rekordu - rozwijane okienko to zastepnik kolumny tabeli
        copyKsefNumber: function (event) {
            const icon = $(event.currentTarget);

            navigator.clipboard.writeText(this.transfer.ksef_number)
                .then(function () {
                    icon.addClass('flash');

                    // usuwamy klase po animacji, zeby dalo sie odpalic ponownie
                    setTimeout(function () {
                        icon.removeClass('flash');
                    }, 600);
                })
                .catch(function (err) {
                    console.error('Blad kopiowania: ', err);
                });
        },
        clickIcon: function () {
            if (this.transfer.made_from === 'document' && this.transfer.status === 'not_confirmed') {
                events.$emit('showIncompleteModal', this.transfer.document_number, this.transfer.remarks, this.transfer.substatus);
            }
        },
        openModalCheckVatList(){
            const _this = this;
            let foundBankAccountId = this.transfer.bank_accounts.find((item) => {
                return item.account_number === _this.transfer.account_number;
            });


            let contractorId = this.transfer.contractor.id;
            let bankAccountId = foundBankAccountId.id;
            let bankAccountNumber = (_this.list_type == 'iban_swift' || _this.list_type == 'iban_sepa') ? _this.transfer.account_number.substring(2) : _this.transfer.account_number;

            doAjax('/records/contractors/check-white-list-payer-account',{
                contractor_id : contractorId,
                bank_account_id: bankAccountId,
                bank_account_number : bankAccountNumber,
            }).then((response) => {
                _this.fillModalWhiteListInfoBox(response.info)
                _this.toggleVisibilityCheckButton(response.can_check)
            })
            $('#modal-check-white-list').modal('show')
        },
        fillModalWhiteListInfoBox(text)
        {
            $('.modal-check-white-list-body-text').text(text);
        },
        toggleVisibilityCheckButton(visible){
            if(visible){
                $('.btn-check-in-white-list').show()
                this.registerCheckButtonWhiteListHandler();
            }
            else{
                $('.btn-check-in-white-list').hide()
            }
        },
        getContractorNumberToShowWhiteListIcon(){
            if(this.transfer.contractor.id_number_type == 'NIP'){
                return this.transfer.contractor.id_number;
            }
            else if(this.transfer.contractor.id_number_type == 'NIP UE'){
                return this.transfer.contractor.id_number.substring(2);
            }
            else if(this.transfer.contractor.second_id_number_type == 'NIP'){
                return this.transfer.contractor.second_id_number;
            }
            else if(this.transfer.contractor.second_id_number_type == 'NIP UE'){
                return this.transfer.contractor.second_id_number.substring(2);
            }
        },
        registerCheckButtonWhiteListHandler(){
            const _this = this;
            $('.btn-check-in-white-list').off('click').on('click', function (){
                toggleLoader(true);
                let contractorId = _this.transfer.contractor.id;
                let foundBankAccountId = _this.transfer.bank_accounts.find((item) => {
                    return item.account_number === _this.transfer.account_number;
                });
                let bankAccountId = foundBankAccountId.id;
                let bankAccountNumber = (_this.list_type == 'iban_swift' || _this.list_type == 'iban_sepa') ? _this.transfer.account_number.substring(2) : _this.transfer.account_number ;
                let idNumber = _this.getContractorNumberToShowWhiteListIcon()
                doAjax('/records/contractors/store-white-list-verification',{
                    contractor_id : contractorId,
                    bank_account_id: bankAccountId,
                    bank_account_number : bankAccountNumber,
                    id_number: idNumber
                }).then((response) => {
                    doAjax('/records/contractors/check-white-list-payer-account',{
                        contractor_id : contractorId,
                        bank_account_id: bankAccountId,
                        bank_account_number : bankAccountNumber,
                    }).then((response) => {
                        _this.fillModalWhiteListInfoBox(response.info)
                        _this.toggleVisibilityCheckButton(response.can_check)
                        _this.checkVatListLabelClass(response.status)
                        toggleLoader(false);
                    })
                })


            })
        },
        checkVatListLabelClass() {
            const _this = this;
            if (this.transfer) {
                let foundBankAccountId = this.transfer.bank_accounts.find((item) => {
                    return item.account_number === _this.transfer.account_number;
                });

                if (!foundBankAccountId) {
                    this.labelClass = 'label label-danger'; // Obsługa przypadku, gdy brak konta
                    return;
                }

                let contractorId = this.transfer.contractor.id;
                let bankAccountId = foundBankAccountId.id;
                let bankAccountNumber = (this.list_type == 'iban_swift' || this.list_type == 'iban_sepa') ? this.transfer.account_number.substring(2) : this.transfer.account_number;

                doAjax('/records/contractors/check-white-list-payer-account', {
                    contractor_id: contractorId,
                    bank_account_id: bankAccountId,
                    bank_account_number: bankAccountNumber,
                }).then((response) => {
                    if (response.status === 'no_confirmation') {
                        this.labelClass = 'label label-danger';
                    } else if (response.status === 'actual') {
                        this.labelClass = 'label label-primary';
                    } else if (response.status === 'not_actual') {
                        this.labelClass = 'label label-warning';
                    }
                }).catch(() => {
                    this.labelClass = 'label label-danger'; // Obsługa błędu
                });
            } else {
                this.labelClass = ''; // Brak transferu
            }
        }
    },
    computed:{
        //IK Numer KSeF: tylko przelewy z dokumentow z numerem KSeF, w boxach PL / IBAN-SEPA / IBAN-SWIFT
        //(o tym, czy numer w ogole trafia do pamieci, decyduje ustawienie use_ksef_number_in_transfer)
        showKsefNumberIcon(){
            return !!this.transfer.ksef_number
                && ['pl', 'iban_sepa', 'iban_swift'].indexOf(this.list_type) !== -1;
        },
        showCheckVatListIcon(){
            if((this.list_type == 'iban_swift' || this.list_type == 'iban_sepa') && (this.transfer.contractor.id_number_type == 'NIP' || this.transfer.contractor.id_number_type == 'NIP UE')){
                return  this.transfer.account_number.substring(0,2) == 'PL'
            }
            return (this.list_type == 'pl' || this.list_type == 'iban_swift' || this.list_type == 'iban_sepa' ) && (this.transfer.contractor.id_number_type == 'NIP' || this.transfer.contractor.id_number_type == 'NIP UE')
        },
    },
    watch:{
        transfer: {
            handler: 'checkVatListLabelClass',
            deep: true
        }
    },
    mounted() {
        // Inicjalizacja logiki, jeśli transfer już istnieje
        if (this.transfer) {
            this.checkVatListLabelClass();
        }
    }
}
</script>

<style>
/* IK "e" ma wygladac jak pozostale ikony w kolumnie, a nie jak przycisk */
.ksef-number-dropdown .btn-ksef-number {
    padding: 0;
    border: 0;
    line-height: 1;
    vertical-align: baseline;
}

.ksef-number-dropdown .btn-ksef-number:focus,
.ksef-number-dropdown .btn-ksef-number:active {
    box-shadow: none;
}

.ksef-number-menu {
    min-width: 0;
    padding: 6px 10px;
    font-size: 12px;
}
</style>
